/*const magasins  =[
    {value: 'conthey',label: 'Conthey'},
    {value: 'lausanne',label: 'Lausanne'},
    {value: 'neuchatel',label: 'Neuchâtel'},
    {value: 'fribourg',label: 'Fribourg'},
    {value: 'geneve',label: 'Genève'},
    {value: 'yverdon',label: 'Yverdon'},
    ];*/

const getDefaultState = () => {
    return {
        warehouseswpa: [

            {value:67,label:'Cointrin'},
            {value:47,label:'Conthey'},
            {value:68,label:'Crissier'},
            {value:70,label:'Entrepôt Suisse'},
            {value:65,label:'Entrepôt Web'},
            {value:60,label:'Fribourg'},
            {value:46,label:'Genève'},
            {value:49,label:'Lausanne'},
            {value:69,label:'Meyrin'},
            {value:61,label:'Neuchâtel'},
            {value:66,label:'Vevey'},
            {value:64,label:'Villeneuve'},
            {value:62,label:'Yverdon'},
            {value:1,label:'Strömer Store'},
            {value:63,label:'ABUS'},
            {value:51,label:'Chrissports'},
            {value:59,label:'CUAG'},
            {value:55,label:'Fuchs-Movesa'},
            {value:58,label:'GPR AG'},
            {value:50,label:'Moto Marketing'},
            {value:57,label:'Ortlieb'},
            {value:54,label:'Trek'},
            {value:56,label:'TST'}

        ]
    }
}


// initial state
const state = getDefaultState()


const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState())
    }
}

const getters = {
    get_warehouses(state) {
        return state.warehouseswpa
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
